import { computed } from '@vue/composition-api'
import formatDate from '@/utils/formatDate'

const sortByDate = messages => messages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

export default function (messagesRaw, userId) {
  const messages = computed(() => sortByDate(messagesRaw.value).map((item) => {
    const isYours = Number(item.userId) === Number(userId.value)

    return {
      ...item,
      date: formatDate(new Date(item.createdAt)),
      from: ['dispatcher', 'admin'].includes(item.userRole) ? 'Сообщение администрации' : 'Сообщение пользователя',
      yours: isYours,
    }
  }))

  return {
    messages,
  }
}
